import RemoveButton from "@/components/RemoveButton";
import {
  NewsFilter,
  updateNewsFilter,
  updateManyNewsFilters,
} from "@/lib/redux/newsFilters/newsFiltersSlice";
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { newsFilterSelectors } from "@/lib/redux/store";
import { useMemo } from "react";
import { Container } from "./styles";
import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";

const isSelected = (filter: NewsFilter, value: string) => {
  return filter.selectedValues.includes(value);
};

const Badges: React.FC = () => {
  const { locale = "it" } = useRouter();

  const t: Record<string, string | undefined> = {
    removeAll: useTranslation("filters.removeAll", locale) || "",
  };
  const dispatch = useAppDispatch();

  const filters = useAppSelector(newsFilterSelectors.selectAll);

  const unselectFilterValue = (filter: NewsFilter, value: string) => {
    const selectedValues = new Set(filter.selectedValues);
    selectedValues.delete(value);
    dispatch(
      updateNewsFilter({
        id: filter.id,
        changes: {
          selectedValues: Array.from(selectedValues),
        },
      })
    );
  };

  const unselectAllFilterValues = () => {
    dispatch(
      updateManyNewsFilters(
        filters.map((filter) => ({
          id: filter.id,
          changes: {
            selectedValues: [],
          },
        }))
      )
    );
  };

  const selectedValuesTotal = useMemo(() => {
    let total = 0;
    filters.forEach((filter) => (total += filter.selectedValues.length));
    return total;
  }, [filters]);

  return (
    <Container>
      {filters.map((filter) => {
        return filter.values.map((value) => {
          if (isSelected(filter, value)) {
            return (
              <RemoveButton
                key={`${filter.id}:${value}`}
                onClick={() => unselectFilterValue(filter, value)}
              >
                {value.split(":")[0]}
              </RemoveButton>
            );
          } else {
            return null;
          }
        });
      })}
      {selectedValuesTotal > 0 && (
        <RemoveButton
          onClick={() => unselectAllFilterValues()}
          colorScheme="light"
        >
          {t.removeAll}
        </RemoveButton>
      )}
    </Container>
  );
};

export default Badges;
